<template>
  <div class="servers-health">
    <div class="health-card" v-for="(item, index) in items" :key="index" :class="getClasses(item.status)">
      <h3>{{ item.server_name }}</h3>
      <p :class="getTextClasses(item.status)">{{ item.status }}</p>
      <p>{{ item.details }}</p>
    </div>
  </div>
</template>
<script>
import StatusIndicator from '@/components/StatusIndicator'
export default {
  name: 'DashboardServersHealth',
  comments: {
    StatusIndicator
  },
  props: {
    items: {
      type: Array,
      default() {
        return {}
      }
    },
    configs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    getClasses(status) {
      switch (status) {
        case 'OFFLINE':
          return 'grey-dark'
        case 'STANDBY':
          return 'danger'
        case 'processing':
          return 'grey'
        case 'stopped':
          return 'danger'
        default:
          return 'success'
      }
    },
    getTextClasses(status) {
      switch (status) {
        case 'OFFLINE':
          return 'has-text-grey-dark'
        case 'STANDBY':
          return 'has-text-danger'
        case 'processing':
          return 'has-text-grey'
        case 'stopped':
          return 'has-text-danger'
        default:
          return 'has-text-success'
      }
    }
  }
}
</script>

<style lang="scss">
.servers-health {
  display: flex;
  flex-flow: wrap;
  width: 100%;
  height: 100%;
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
  .health-card {
    h3 {
      font-weight: bold;
    }
    padding: 0.5rem;
    display: flex;
    justify-content: center;
    border: 0.0625rem solid #ccc;
    width: 10rem;
    flex-direction: column;
    margin-bottom: 1rem;
    margin-right: 1rem;
    text-align: center;
    &.grey-dark {
      background-color: #bbbbbb;
    }
    &.grey {
      background-color: #bbbbbb;
    }
    &.danger {
      background-color: #ffc9c9;
    }
    &.success {
      background-color: #c5ffc2;
    }
  }
}
</style>
